import { SnackbarProvider } from 'notistack';

function WatershedSnackbarProvider(props: any) {
  return (
    <SnackbarProvider maxSnack={4} autoHideDuration={3000}>
      {props.children}
    </SnackbarProvider>
  );
}

export { WatershedSnackbarProvider };
